import DefaultButton from 'components/button/DefaultButton';
import DefaultLayout from 'components/layout/DefaultLayout';
import TableToolbar from 'components/table/TableToolbar';
import React, { useState } from 'react';
import PackageRegisterModal from './PackageRegisterModal';
import MainTable from 'components/table/MainTable';
import { usePackageList } from 'hooks/queries/package/packageQuery';
import TextButton from 'components/button/TextButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
/**
 * * 패키지 관리 - 목록
 * - 등록된 패키지가 특정 작품을 연결하는 과정 수행
 */

const PackageListPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState<boolean>(false);
  const { data: packageList } = usePackageList();

  const handleLink = (record) => () => {
    navigate(`${record.package_id}/appInformation`, {
      state: { record: record },
    });
  };

  const columnsOrigin = [
    {
      title: t('package.table.packageID'),
      dataIndex: 'package_id',
      width: '8rem',
      sorter: (a, b) => a.package_name.localeCompare(b.package_name),
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('package.table.packageName'),
      dataIndex: 'package_name',
      width: '12rem',
      sorter: (a, b) => a.package_name.localeCompare(b.package_name),
      render: (text, record) => (
        <TextButton onClick={handleLink(record)}>{text}</TextButton>
      ),
    },
    {
      title: t('package.table.packageSummary'),
      dataIndex: 'package_summary',
      width: '18rem',
    },
    {
      title: t('package.table.projectName'),
      dataIndex: 'project_name',
      width: '8rem',
    },
  ];
  return (
    <>
      <DefaultLayout>
        <TableToolbar>
          <div></div>
          <DefaultButton onClick={() => setVisible(true)}>
            {t('package.header.addPackageButton')}
          </DefaultButton>
        </TableToolbar>
        <MainTable columns={columnsOrigin} dataSource={packageList} />
      </DefaultLayout>
      <PackageRegisterModal visible={visible} setVisible={setVisible} />
    </>
  );
};

export default PackageListPage;
